var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyFilterResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 259,
    viewBox: "0 0 322 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6144_152611)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6144_152611)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.179,
    y: 62.365,
    width: 189.093,
    height: 161.779,
    rx: 16.1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1915,
    y: 64.3775,
    width: 185.068,
    height: 157.754,
    rx: 14.0875,
    stroke: "#008BFF",
    strokeWidth: 4.025
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.279 64.3775H240.172C247.952 64.3775 254.259 70.6847 254.259 78.465V86.6153H69.1915V78.465C69.1915 70.6847 75.4987 64.3775 83.279 64.3775Z",
    fill: "#E8F5FC",
    stroke: "#008BFF",
    strokeWidth: 4.025
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_6144_152611)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.1792,
    y: 62.365,
    width: 189.093,
    height: 161.779,
    rx: 16.1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1917,
    y: 64.3775,
    width: 185.068,
    height: 157.754,
    rx: 14.0875,
    stroke: "#008BFF",
    strokeWidth: 4.025
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.7 124.775L114.742 123.958C116.661 123.191 118.802 123.191 120.721 123.958L122.763 124.775",
    stroke: "#008BFF",
    strokeWidth: 3.01875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.238 124.775L201.279 123.958C203.198 123.191 205.339 123.191 207.258 123.958L209.3 124.775",
    stroke: "#008BFF",
    strokeWidth: 3.01875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 180.123C158.107 180.122 155.365 178.362 153.301 175.263C151.242 172.172 149.936 167.843 149.938 163.013C149.94 158.182 151.249 153.855 153.31 150.765C155.377 147.668 158.12 145.909 161.013 145.911C163.907 145.912 166.649 147.672 168.713 150.77C170.772 153.862 172.077 158.19 172.076 163.021C172.074 167.852 170.765 172.179 168.703 175.269C166.637 178.366 163.894 180.124 161 180.123Z",
    fill: "#008BFF",
    stroke: "#008BFF",
    strokeWidth: 2.0125
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.902 170.144C150.44 171.043 150.414 172.103 150.826 173.025C153.01 177.906 156.746 181.123 160.989 181.125C164.947 181.126 168.465 178.329 170.696 173.993C171.158 173.095 171.184 172.035 170.771 171.113C168.587 166.232 164.851 163.014 160.609 163.012C156.651 163.011 153.132 165.808 150.902 170.144Z",
    fill: "#E8F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.279 64.3775H240.172C247.952 64.3775 254.259 70.6847 254.259 78.465V86.6153H69.1915V78.465C69.1915 70.6847 75.4987 64.3775 83.279 64.3775Z",
    fill: "#E8F5FC",
    stroke: "#008BFF",
    strokeWidth: 4.025
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.604,
    cy: 139.039,
    rx: 4.20205,
    ry: 4.20206,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.797,
    cy: 139.039,
    rx: 4.20204,
    ry: 4.20206,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1124 145.881C44.1124 148.516 41.976 150.652 39.3408 150.652C36.7055 150.652 34.5692 148.516 34.5692 145.881C34.5692 143.246 36.7055 141.109 39.3408 141.109C41.976 141.109 44.1124 143.246 44.1124 145.881Z",
    stroke: "#008BFF",
    strokeWidth: 2.0125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9604 190.528L54.4369 197.497L60.8761 197.746L54.573 200.789L51.9604 207.336L49.8457 200.788L45.1184 199.267L49.8457 197.745L51.9604 190.528Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.306 159.012L278.773 168.595L287.788 168.937L278.963 173.121L275.306 182.123L272.345 173.12L265.727 171.029L272.345 168.936L275.306 159.012Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.689 107.332L273.559 112.455L277.867 114.397L272.797 114.587L269.322 118.031L269.587 113.277L266.773 110.999L270.378 111.34L273.689 107.332Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7087 89.0078L51.8459 92.5763L54.33 94.2716L51.029 94.0065L48.2625 96.1395L49.1571 92.8391L47.6874 91.0267L49.9621 91.548L52.7087 89.0078Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.535 57.235L282.292 41.4773",
    stroke: "#008BFF",
    strokeWidth: 4.025,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.546 77.1953H268.636",
    stroke: "#008BFF",
    strokeWidth: 4.025,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.525 55.1344V36.2251",
    stroke: "#008BFF",
    strokeWidth: 4.025,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6144_152611",
    x: 34.979,
    y: 46.265,
    width: 253.493,
    height: 226.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6144_152611"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.025
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6144_152611",
    result: "effect2_dropShadow_6144_152611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6144_152611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_6144_152611",
    x: 34.9792,
    y: 46.265,
    width: 253.493,
    height: 226.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6144_152611"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.025
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6144_152611",
    result: "effect2_dropShadow_6144_152611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6144_152611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6144_152611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 322,
    height: 258.395,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilterResult);
export default __webpack_public_path__ + "static/media/EmptyFilterResult.6f2c884a025d20acf0e9f3f4bad8fefa.svg";
export { ForwardRef as ReactComponent };